import { render } from "./RecoverMail.vue?vue&type=template&id=57a3a922&scoped=true"
import script from "./RecoverMail.vue?vue&type=script&lang=js"
export * from "./RecoverMail.vue?vue&type=script&lang=js"

import "./RecoverMail.vue?vue&type=style&index=0&id=57a3a922&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a3a922"]])

export default __exports__